<template>
  <div class="container py-4 col-12 col-lg-10" id="container">

    <!-- TÍTULO -->
    <section class="projetos-cabecalho page-header mb-md-5">
      <div class="col-12 p-0">
        <p class="page-header-eyebrow">PÁGINA INICIAL</p>
        <h1 class="page-title mb-1">Projetos</h1>
      </div>
    </section>

    <!-- BUSCA + BOTÃO -->
    <section class="projetos-filtros row mb-4 align-items-end g-2">

      <!-- BUSCA -->
      <div class="col-12 col-md-6 col-lg-7">
        <label class="form-label" for="searchInput">Pesquisar</label>
        <form class="position-relative">
          <span class="position-absolute start-0 top-50 translate-middle-y ps-3 pb-1">
            <img src="../img/search-icon.svg" alt="Buscar">
          </span>

          <input
            class="lupa-busca form-control ps-5"
            type="search"
            placeholder="Buscar"
            v-model="search"
          />
        </form>
      </div>

      <!-- SELECT -->
      <div class="col-12 col-md-3 col-lg-3 d-none d-md-block">
        <label class="form-label">Visualização</label>
        <select class="form-select w-100" v-model="modoVisualizacao">
          <option value="lista">Lista</option>
          <option value="blocos">Blocos</option>
        </select>
      </div>

      <!-- BOTÃO -->
      <div class="col-8 col-md-3 col-lg-2">
        <label class="form-label d-none d-md-block">&nbsp;</label>
        <button
          class="botao-azul btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2 tour-novo-projeto"
          data-bs-toggle="modal"
          data-bs-target="#adicionarProjetoModal"
        >
          <b>Novo projeto</b>
        </button>
      </div>

    </section>

    <!-- TABELA -->
    <div class="table-responsive tabela-projetos-container" v-if="modoVisualizacao === 'lista'">

      <h3 class="titulo-secao-projeto">Meus Projetos</h3>

      <table
        class="table tabela-projetos align-middle"
        v-if="projetos && projetos.length"
      >

      <!-- Define o tamnaho das colunas da tabela -->
      <colgroup>
        <col />
        <col style="width: 180px" />
        <col style="width: 130px" />
        <col style="width: 180px" />
      </colgroup>

        <thead>
          <tr>
            <th>Nome</th>
            <th class="text-nowrap">Criado Por</th>
            <th>Data</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="projeto in projetosPaginados" :key="projeto.ordem">
            
            <!-- NAME -->
            <td>
              <router-link
                :to="`/app/project/${projeto.cod}`"
                class="text-decoration-none titulo-projeto d-flex align-items-center"
              >
                <img
                  src="../img/folder-icon.svg"
                  alt="Folder"
                  width="40"
                  height="40"
                  class="me-2"
                >
                <!-- texto wrap -->
                <span class="text-nowrap">{{ projeto.nome }}</span>
              </router-link>
            </td>
            <td class="text-nowrap">{{ abreviarNome(projeto.autor) }}</td>
            <td class="text-nowrap">{{ converterDataBrasil(projeto.dataCriacao) }}</td>
            
            <!-- ACTIONS -->
            <td class="text-center">
              
              <div class="btn-group" role="group" aria-label="Button group with nested dropdown">

                <!-- ABRIR -->
                 <router-link
                :to="`/app/project/${projeto.cod}`"
                class="btn btn-sm btn-secundario text-decoration-none"
                >
                  <b>Abrir</b>
                </router-link>

                <!-- DROPDOWN -->
                <div class="btn-group">
                  <button
                    type="button"
                    class="btn btn-sm btn-secundario dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-display="static"
                    aria-expanded="false"
                  >
                    <b>Opções</b>
                  </button>

                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <button 
                        class="dropdown-item"
                        @click="abrirModalRename(projeto)"
                        data-bs-toggle="modal"
                        data-bs-target="#renomearProjetoModal"
                      >
                        <i class="bi bi-pencil me-1"></i> Renomear
                      </button>
                    </li>

                    <li>
                      <button 
                        class="dropdown-item"
                        @click="duplicarProjeto(projeto)"
                      >
                        <i class="bi bi-files me-1"></i> Duplicar
                      </button>
                    </li>

                    <li>
                      <button 
                        class="dropdown-item"
                        @click="abrirModalDelete(projeto)"
                        data-bs-toggle="modal"
                        data-bs-target="#deletarProjetoModal"
                      >
                        <i class="bi bi-trash me-1"></i> Excluir
                      </button>
                    </li>

                    <li>
                      <button
                        class="dropdown-item"
                        @click="abrirModalCompartilhar(projeto)"
                        data-bs-toggle="modal"
                        data-bs-dismiss="modal"
                        data-bs-target="#compartilharProjetoModal"
                      >
                        <i class="bi bi-share me-1"></i> Compartilhar
                      </button>
                    </li>
                  </ul>
                </div>

              </div>

            </td>

          </tr>
        </tbody>
      </table>

      <nav
        v-if="totalPaginas > 1"
        class="d-flex justify-content-center mt-3"
        aria-label="Paginação dos meus projetos"
      >
        <ul class="pagination pagination-projetos mb-0">
          <li class="page-item" :class="{ disabled: paginaAtual === 1 }">
            <button
              type="button"
              class="page-link"
              :disabled="paginaAtual === 1"
              @click="irParaPagina(paginaAtual - 1)"
            >
              Anterior
            </button>
          </li>
          <li
            v-for="pagina in totalPaginas"
            :key="pagina"
            class="page-item"
            :class="{ active: paginaAtual === pagina }"
          >
            <button
              type="button"
              class="page-link"
              @click="irParaPagina(pagina)"
            >
              {{ pagina }}
            </button>
          </li>
          <li class="page-item" :class="{ disabled: paginaAtual === totalPaginas }">
            <button
              type="button"
              class="page-link"
              :disabled="paginaAtual === totalPaginas"
              @click="irParaPagina(paginaAtual + 1)"
            >
              Próxima
            </button>
          </li>
        </ul>
      </nav>
    </div>

    <!-- PROJETOS NÃO ENCONTRADOS NA LISTA -->
    <div
      v-if="modoVisualizacao === 'lista' && projetos && projetos.length === 0"
      class="d-flex flex-column align-items-center justify-content-center text-center py-5"
    >
      <img
        src="../img/folder-empty-icon.svg"
        alt="No projects"
        width="56"
        height="56"
        class="mb-3"
      >

      <h5 class="fw-semibold mb-2">Nenhum projeto encontrado</h5>

      <p class="text-muted mb-4" style="max-width: 360px;">
        Oops! Você ainda não tem nenhum projeto.
        <br>Que tal começar um agora?
      </p>

      <button
        class="botao-azul btn btn-primary d-flex flex-nowrap align-items-center gap-2 text-nowrap tour-novo-projeto"
        data-bs-toggle="modal"
        data-bs-target="#adicionarProjetoModal"
      >
        <img src="../img/new-project-icon.svg" alt="Novo Projeto" width="20" height="20">
        <b>Novo projeto</b>
      </button>
    </div>

    <!-- TABELA PROJETOS COMPARTILHADOS-->
    <div class="table-responsive tabela-projetos-container" v-if="modoVisualizacao === 'lista' && projetosCompartilhados && projetosCompartilhados.length">

      <h2 class="titulo-secao-projeto titulo-secao-projeto-compartilhados">Projetos Compartilhados</h2>

      <table
        class="table tabela-projetos align-middle"
        v-if="projetos && projetos.length"
      >

      <!-- Define o tamnaho das colunas da tabela -->
      <colgroup>
        <col />
        <col style="width: 180px" />
        <col style="width: 130px" />
        <col style="width: 180px" />
      </colgroup>

        <thead>
          <tr>
            <th>Nome</th>
            <th class="text-nowrap">Criado Por</th>
            <th>Data</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="projeto in projetosCompartilhadosPaginados" :key="projeto.ordem">
            
            <!-- NAME -->
            <td>
              <router-link
                :to="`/app/project/${projeto.cod}`"
                class="text-decoration-none titulo-projeto d-flex align-items-center"
              >
                <img
                  src="../img/folder-icon.svg"
                  alt="Folder"
                  width="40"
                  height="40"
                  class="me-2"
                >
                <!-- texto wrap -->
                <span class="text-nowrap">{{ projeto.nome }}</span>
              </router-link>
            </td>

            <td class="text-nowrap">{{ abreviarNome(projeto.autor) }}</td>
            <td class="text-nowrap">{{ converterDataBrasil(projeto.dataCriacao) }}</td>

            <!-- ACTIONS -->
            <td class="text-center">
              <div class="btn-group" role="group" aria-label="Button group with nested dropdown">

                <!-- ABRIR -->
                 <router-link
                :to="`/app/project/${projeto.cod}`"
                class="btn btn-sm btn-secundario text-decoration-none"
                >
                  <b>Abrir</b>
                </router-link>

              </div>
            </td>

          </tr>
        </tbody>
      </table>

      <nav
        v-if="totalPaginasCompartilhados > 1"
        class="d-flex justify-content-center mt-3"
        aria-label="Paginação dos projetos compartilhados"
      >
        <ul class="pagination pagination-projetos mb-0">
          <li class="page-item" :class="{ disabled: paginaCompartilhadosAtual === 1 }">
            <button
              type="button"
              class="page-link"
              :disabled="paginaCompartilhadosAtual === 1"
              @click="irParaPaginaCompartilhados(paginaCompartilhadosAtual - 1)"
            >
              Anterior
            </button>
          </li>
          <li
            v-for="pagina in totalPaginasCompartilhados"
            :key="pagina"
            class="page-item"
            :class="{ active: paginaCompartilhadosAtual === pagina }"
          >
            <button
              type="button"
              class="page-link"
              @click="irParaPaginaCompartilhados(pagina)"
            >
              {{ pagina }}
            </button>
          </li>
          <li class="page-item" :class="{ disabled: paginaCompartilhadosAtual === totalPaginasCompartilhados }">
            <button
              type="button"
              class="page-link"
              :disabled="paginaCompartilhadosAtual === totalPaginasCompartilhados"
              @click="irParaPaginaCompartilhados(paginaCompartilhadosAtual + 1)"
            >
              Próxima
            </button>
          </li>
        </ul>
      </nav>
    </div>

    <!-- BLOCOS -->
    <div
      class="row g-3"
      v-if="modoVisualizacao === 'blocos'"
    >

    <h3 class="titulo-secao-projeto">Meus Projetos</h3>

      <div
        v-for="projeto in projetosPaginados"
        :key="projeto.cod"
        class="icones-projetos col-12 col-sm-6 col-md-4 col-lg-4"
      >
        <div class="card projeto-card h-100">

          <!-- MENU AÇÕES -->
          <div class="dropdown projeto-menu">
            <button
              class="btn btn-sm btn-light" id="tres-pontinhos-projetos"
              data-bs-toggle="dropdown"
            >
              <i class="bi bi-three-dots-vertical "></i>
            </button>

            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <button class="dropdown-item" @click="abrirModalRename(projeto)" data-bs-toggle="modal" data-bs-target="#renomearProjetoModal">
                  <i class="bi bi-pencil me-1"></i> Renomear
                </button>
              </li>
              <li>
                <button class="dropdown-item" @click="duplicarProjeto(projeto)">
                  <i class="bi bi-files me-1"></i> Duplicar
                </button>
              </li>
              <li>
                <button class="dropdown-item" @click="abrirModalDelete(projeto)" data-bs-toggle="modal" data-bs-target="#deletarProjetoModal">
                  <i class="bi bi-trash me-1"></i> Excluir
                </button>
              </li>
              <li>
                <button
                  class="dropdown-item"
                  @click="abrirModalCompartilhar(projeto)"
                  data-bs-toggle="modal"
                  data-bs-dismiss="modal"
                  data-bs-target="#compartilharProjetoModal"
                >
                  <i class="bi bi-share me-1"></i> Compartilhar
                </button>
              </li>
            </ul>
          </div>

          <!-- CONTEÚDO -->
          <router-link
            :to="`/app/project/${projeto.cod}`"
            class="text-decoration-none text-dark"
          >
            <div class="card-body text-center">

              <div class="folder-icon mb-3">
                <img src="../img/folder-icon.svg" width="96" />
              </div>

              <h5 class="projeto-nome mb-3">
                {{ projeto.nome }}
              </h5>

              <!-- <small class="text-muted d-block"> -->
                {{ abreviarNome(projeto.autor) }}
              <!-- </small> -->

              <!-- <small class="text-muted"> -->
                <br>{{ converterDataBrasil(projeto.dataCriacao) }}
              <!-- </small> -->

              <i
                v-if="projetoCompartilhado(projeto)"
                  class="bi bi-share-fill projeto-compartilhado-icon"
                  title="Projeto compartilhado"
                >
              </i>

            </div>
          </router-link>
        </div>
      </div>

      <nav
        v-if="totalPaginas > 1"
        class="col-12 d-flex justify-content-center mt-3"
        aria-label="Paginação dos meus projetos"
      >
        <ul class="pagination pagination-projetos mb-0">
          <li class="page-item" :class="{ disabled: paginaAtual === 1 }">
            <button type="button" class="page-link" :disabled="paginaAtual === 1" @click="irParaPagina(paginaAtual - 1)">Anterior</button>
          </li>
          <li v-for="pagina in totalPaginas" :key="pagina" class="page-item" :class="{ active: paginaAtual === pagina }">
            <button type="button" class="page-link" @click="irParaPagina(pagina)">{{ pagina }}</button>
          </li>
          <li class="page-item" :class="{ disabled: paginaAtual === totalPaginas }">
            <button type="button" class="page-link" :disabled="paginaAtual === totalPaginas" @click="irParaPagina(paginaAtual + 1)">Próxima</button>
          </li>
        </ul>
      </nav>

          <!-- Projects not found -->
    <div
      v-if="projetos && projetos.length === 0"
      class="d-flex flex-column align-items-center justify-content-center text-center py-5"
    >
      <img
        src="../img/folder-empty-icon.svg"
        alt="No projects"
        width="56"
        height="56"
        class="mb-3"
      >

      <h5 class="fw-semibold mb-2">Nenhum projeto encontrado</h5>

      <p class="text-muted mb-4" style="max-width: 360px;">
        Oops! Você ainda não tem nenhum projeto.
        <br>Que tal começar um agora?
      </p>

      <button
        class="botao-azul btn btn-primary d-flex flex-nowrap align-items-center gap-2 text-nowrap tour-novo-projeto"
        data-bs-toggle="modal"
        data-bs-target="#adicionarProjetoModal"
      >
        <img src="../img/new-project-icon.svg" alt="Novo Projeto" width="20" height="20">
        <b>Novo projeto</b>
      </button>
    </div>

      <!-- BLOCOS - PROJETOS COMPARTILHADOS -->
      <div v-if="projetosCompartilhados && projetosCompartilhados.length" class="projetos-compartilhados-blocos">

        <h2 class="titulo-secao-projeto titulo-secao-projeto-compartilhados">Projetos Compartilhados</h2>

        <div class="row g-3">
          <div
            v-for="projeto in projetosCompartilhadosPaginados"
            :key="projeto.cod"
            class="icones-projetos col-12 col-sm-6 col-md-4 col-lg-4"
          >
            <div class="card projeto-card h-100">

              <!-- CONTEÚDO -->
              <router-link
                :to="`/app/project/${projeto.cod}`"
                class="text-decoration-none text-dark"
              >
                <div class="card-body text-center">

                  <div class="folder-icon mb-3">
                    <img src="../img/folder-icon.svg" width="96" />
                  </div>

                  <h5 class="projeto-nome mb-3">
                    {{ projeto.nome }}
                  </h5>

                  <!-- <small class="text-muted d-block"> -->
                    {{ abreviarNome(projeto.autor) }}
                  <!-- </small> -->

                  <!-- <small class="text-muted"> -->
                    <br>{{ converterDataBrasil(projeto.dataCriacao) }}
                  <!-- </small> -->

                  <i
                    v-if="projetoCompartilhado(projeto)"
                      class="bi bi-share-fill projeto-compartilhado-icon"
                      title="Projeto compartilhado"
                  >
                  </i>

                </div>
              </router-link>
            </div>
          </div>
        </div>

        <nav
          v-if="totalPaginasCompartilhados > 1"
          class="d-flex justify-content-center mt-3"
          aria-label="Paginação dos projetos compartilhados"
        >
          <ul class="pagination pagination-projetos mb-0">
            <li class="page-item" :class="{ disabled: paginaCompartilhadosAtual === 1 }">
              <button type="button" class="page-link" :disabled="paginaCompartilhadosAtual === 1" @click="irParaPaginaCompartilhados(paginaCompartilhadosAtual - 1)">Anterior</button>
            </li>
            <li v-for="pagina in totalPaginasCompartilhados" :key="pagina" class="page-item" :class="{ active: paginaCompartilhadosAtual === pagina }">
              <button type="button" class="page-link" @click="irParaPaginaCompartilhados(pagina)">{{ pagina }}</button>
            </li>
            <li class="page-item" :class="{ disabled: paginaCompartilhadosAtual === totalPaginasCompartilhados }">
              <button type="button" class="page-link" :disabled="paginaCompartilhadosAtual === totalPaginasCompartilhados" @click="irParaPaginaCompartilhados(paginaCompartilhadosAtual + 1)">Próxima</button>
            </li>
          </ul>
        </nav>
      </div>

    </div>

    <!-- MODAL: NOVO PROJETO (FIGMA STYLE) -->
    <div class="modal fade" id="adicionarProjetoModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content modal-novo-projeto">

          <form
            @submit.prevent="criarNovoProjeto"
            @keydown.enter.prevent="criarNovoProjeto"
          >

            <!-- HEADER -->
            <div class="modal-header border-0 pb-2">
              <div class="d-flex align-items-center gap-2">
                <h5 class="modal-title mb-0"><b>Começar um novo projeto</b></h5>
              </div>

              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <!-- BODY -->
            <div class="modal-body pt-0">
              <p class="text-muted mb-3">
                Qual é o nome do projeto?
              </p>

              <input
                type="text"
                class="form-control input-projeto"
                placeholder="Nome do projeto"
                v-model="nomeProjeto"
                required
              >
            </div>

            <!-- FOOTER -->
            <div class="modal-footer border-0 pt-0">

              <button
                type="button"
                class="btn btn-secundario"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>

              <button
                type="button"
                class="btn btn-primary botao-azul d-flex align-items-center gap-2"
                data-bs-dismiss="modal"
                @click="criarNovoProjeto()"
              >
                Criar novo projeto
              </button>

            </div>

          </form>
        </div>
      </div>
    </div>

    <!-- MODAL: RENAME PROJECT -->
    <div class="modal fade" id="renomearProjetoModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content modal-novo-projeto">

          <!-- HEADER -->
          <div class="modal-header border-0 pb-2">
            <div class="d-flex align-items-center gap-2">
              <h5 class="modal-title mb-0">Renomear projeto</h5>
            </div>

            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>

          <!-- BODY -->
          <div class="modal-body pt-0">
            <p class="text-muted mb-3">
              Escolha um novo nome para o seu projeto.
            </p>

            <input
              type="text"
              class="form-control input-projeto" id="renomearComponente"
              placeholder="New project name"
              v-model="novoNomeProjeto"
            >
          </div>

          <!-- FOOTER -->
          <div class="modal-footer border-0 pt-0">

            <button
              type="button"
              class="btn btn-secundario"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>

            <button
              type="submit"
              class="btn btn-primary botao-azul"
              data-bs-dismiss="modal"
              @click="confirmarRename"
            >
              Salvar alterações
            </button>

          </div>

        </div>
      </div>
    </div>

    <!-- MODAL: DELETE PROJECT -->
    <div class="modal fade" id="deletarProjetoModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content modal-novo-projeto">

          <!-- HEADER -->
          <div class="modal-header border-0 pb-2">
            <div class="d-flex align-items-center gap-2">
              <h5 class="modal-title mb-0"><b>Excluir projeto</b></h5>
            </div>

            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>

          <!-- BODY -->
          <div class="modal-body pt-0">
            <p class="text-muted mb-2">
              Tem certeza de que deseja excluir o projeto <strong>{{ projetoSelecionadoParaDeletar?.nomeProjeto }}</strong>?
            </p>
          </div>

          <!-- FOOTER -->
          <div class="modal-footer border-0 pt-0">

            <button
              type="button"
              class="btn btn-secundario"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>

            <button
              type="button"
              class="btn btn-primary botao-azul"
              data-bs-dismiss="modal"
              @click="confirmarDelete"
            >
              Excluir projeto
            </button>

          </div>

        </div>
      </div>
    </div>

    <!-- MODAL: SHARE PROJECT -->
    <div class="modal fade" id="compartilharProjetoModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content modal-novo-projeto">

          <!-- HEADER -->
          <div class="modal-header border-0 pb-2">
            <div class="d-flex align-items-center gap-2">
              <!-- <img src="../img/share-icon.svg" alt="Share" width="20" height="20"> -->
              <h5 class="modal-title mb-0">Compartilhar projeto</h5>
            </div>

            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>

          <!-- BODY -->
          <div class="modal-body pt-0">
            <p class="text-muted mb-3">
              Informe o e-mail do usuário com quem deseja compartilhar este projeto.
            </p>

            <input
              type="email"
              class="form-control input-projeto"
              placeholder="email@exemplo.com"
              v-model="emailCompartilhar"
              required
            />

            <div
              v-if="projetoSelecionadoParaCompartilhar?.emailsCompartilhados?.length"
              class="compartilhamentos-lista mt-4"
            >
              <div class="compartilhamentos-lista__cabecalho">
                <div>
                  <span class="compartilhamentos-lista__titulo">Compartilhado com</span>
                  <span class="compartilhamentos-lista__subtitulo">Pessoas com acesso a este projeto</span>
                </div>
                <span class="compartilhamentos-lista__contador">
                  {{ projetoSelecionadoParaCompartilhar.emailsCompartilhados.length }}
                </span>
              </div>

              <div class="table-responsive">
                <table class="table compartilhamentos-tabela align-middle mb-0">
                  <thead>
                    <tr>
                      <th scope="col">Destinatário</th>
                      <th scope="col" class="text-end">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="email in projetoSelecionadoParaCompartilhar.emailsCompartilhados"
                      :key="email"
                    >
                      <td>
                        <div class="compartilhamento-destinatario">
                          <span class="compartilhamento-destinatario__icone" aria-hidden="true">
                            <i class="bi bi-envelope-fill"></i>
                          </span>
                          <span class="compartilhamento-destinatario__email">{{ email }}</span>
                        </div>
                      </td>
                      <td class="text-end">
                        <button
                          type="button"
                          class="compartilhamento-remover"
                          :aria-label="`Remover acesso de ${email}`"
                          :title="`Remover acesso de ${email}`"
                          @click="removerCompartilhamento(email)"
                        >
                          <i class="bi bi-trash3" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- FOOTER -->
          <div class="modal-footer border-0 pt-0">

            <button
              type="button"
              class="btn btn-secundario"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>

            <button
              type="button"
              class="btn btn-primary botao-azul d-flex align-items-center gap-2"
              @click="confirmarCompartilhamento"
            >
              Compartilhar
            </button>

          </div>

        </div>
      </div>
    </div>

    <!-- MODAIS -->
    <AlertModal
      :visible="alertModal.visible"
      :title="alertModal.title"
      :message="alertModal.message"
      :type="alertModal.type"
      @close="fecharAlert"
    />

    <LoadingModal
      :visible="loading.visible"
      :title="loading.title"
      :message="loading.message"
    />

  </div>
</template>

<script>

import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import AlertModal from '@/componentesTelas/AlertModal.vue';
import LoadingModal from '@/componentesTelas/LoadingModal.vue';
import { getUsuario } from '@/utils/authStorage';

export default {
  name: "MeusProjetos",
  data() {
    return {
      nomeProjeto: "",
      projetos: [],
      projetosCompartilhados: [],
      usuarioLogado: null,
      projetoSelecionadoParaRenomear: null,
      projetoSelecionadoParaDeletar: null,
      novoNomeProjeto: '',
      projetoSelecionadoParaCompartilhar: null,
      emailCompartilhar: '',
      search: '',
      paginaAtual: 1,
      paginaCompartilhadosAtual: 1,
      larguraJanela: window.innerWidth,
      modoVisualizacao: localStorage.getItem('meusProjetos.modoVisualizacao') || 'blocos',

      // Modal genérico
      alertModal: {
        visible: false,
        title: '',
        message: '',
        type: 'info'
      },

      // Modal de loading
      loading: {
        visible: false,
      }
    };
  },
  components: {
    AlertModal,
    LoadingModal
  },
  computed: {

    itensPorPagina() {
      if (this.larguraJanela >= 768 && this.larguraJanela < 992) {
        return 6;
      }

      return 8;
    },

    sortedProjetos() {
      const termo = this.search.toLowerCase().trim();

      return [...this.projetos]
        .filter(projeto => {
          if (!termo) return true;
          return String(projeto.nome)
            .toLowerCase()
            .includes(termo);
        })
        .sort((a, b) => {
          const diferencaData = new Date(b.dataCriacao) - new Date(a.dataCriacao);
          return diferencaData || (a.ordem - b.ordem);
        });
    },

    totalPaginas() {
      return Math.max(1, Math.ceil(this.sortedProjetos.length / this.itensPorPagina));
    },

    projetosPaginados() {
      const inicio = (this.paginaAtual - 1) * this.itensPorPagina;
      return this.sortedProjetos.slice(inicio, inicio + this.itensPorPagina);
    },

    totalPaginasCompartilhados() {
      return Math.max(1, Math.ceil(this.sortedProjetosCompartilhados.length / this.itensPorPagina));
    },

    projetosCompartilhadosPaginados() {
      const inicio = (this.paginaCompartilhadosAtual - 1) * this.itensPorPagina;
      return this.sortedProjetosCompartilhados.slice(inicio, inicio + this.itensPorPagina);
    },

    sortedProjetosCompartilhados() {
      const termo = this.search.toLowerCase().trim();

      return [...this.projetosCompartilhados]
        .filter(projeto => {
          if (!termo) return true;
          return String(projeto.nome)
            .toLowerCase()
            .includes(termo);
        })
        .sort((a, b) => {
          const diferencaData = new Date(b.dataCriacao) - new Date(a.dataCriacao);
          return diferencaData || (a.ordem - b.ordem);
        });
    }

  },
  mounted() {

    // FORÇA BLOCOS NO MOBILE
    if (window.innerWidth < 768) {
      this.modoVisualizacao = 'blocos';
    }

    this.ajustarTamanhoCardPrincipal();
    window.addEventListener('resize', this.atualizarLarguraJanela);
    this.usuarioLogado = getUsuario();
    this.abrirLoading();
    this.carregarProjetos();

  },
  watch: {
    search() {
      this.paginaAtual = 1;
      this.paginaCompartilhadosAtual = 1;
    },
    modoVisualizacao(novoValor) {
      localStorage.setItem('meusProjetos.modoVisualizacao', novoValor);
    }
  },
      beforeUnmount() {
        window.removeEventListener('resize', this.atualizarLarguraJanela);
      },
  methods: {

        atualizarLarguraJanela() {
          this.larguraJanela = window.innerWidth;
        },

    abrirAlert(title, message, type = 'info') {
      this.alertModal = {
        visible: true,
        title,
        message,
        type
      };
    },

    fecharAlert() {
      this.alertModal.visible = false;
    },

    abrirLoading() {
      this.loading.visible = true;
    },

    fecharLoading() {
      this.loading.visible = false;
    },

    irParaPagina(pagina) {
      this.paginaAtual = Math.min(Math.max(pagina, 1), this.totalPaginas);
    },

    irParaPaginaCompartilhados(pagina) {
      this.paginaCompartilhadosAtual = Math.min(
        Math.max(pagina, 1),
        this.totalPaginasCompartilhados
      );
    },

    abreviarNome(nome) {
      if (!nome) return '';

      const partes = nome
        .trim()
        .split(' ')
        .filter(Boolean); // 🔑 remove strings vazias

      if (partes.length === 1) return partes[0];

      return `${partes[0]} ${partes[partes.length - 1]}`;
    },

    converterDataBrasil(data) {
      if (!data) return '';

      const partes = data.split('-');
      if (partes.length !== 3) return data;

      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    },
    
    ajustarTamanhoCardPrincipal() {
      const card = document.querySelector(".card-principal");
      if (card) {
        card.style.maxWidth = "1400px";
      }
    },

    projetoCompartilhado(projeto) {
      return (
        !!projeto.compartilhadoPor ||
        (Array.isArray(projeto.emailsCompartilhados) &&
          projeto.emailsCompartilhados.length > 0)
      );
    },

    // Atualize o método carregarProjetos:
    carregarProjetos() {
      
      fetch(`${process.env.VUE_APP_BACKEND_URL}/carregar-projetos-usuario/${this.usuarioLogado.email}`)
        .then(res => res.json())
        .then(data => {
          this.projetos = data.projetos || [];
          this.projetosCompartilhados = data.projetosCompartilhados || [];
        })
        .catch(err => {
          console.error(err);
          this.projetos = [];
        })
        .finally(() => {
          this.fecharLoading();
        });
    },

    // Criar projeto
    criarNovoProjeto() {
      if (!this.nomeProjeto || !this.usuarioLogado) return;

      this.abrirLoading();

      const projeto = {
        cod: 0,
        nome: this.nomeProjeto,
        ordem: 0
      };

      const autor = this.usuarioLogado.nome || 'Unknown';
      const emailAutor = this.usuarioLogado.email || 'Unknown';
      const dataCriacao = new Date().toISOString().split('T')[0];

      fetch(`${process.env.VUE_APP_BACKEND_URL}/criar-novo-projeto-no-usuario`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          projeto,
          email: this.usuarioLogado.email,
          autor,
          emailAutor,
          dataCriacao
        })
      })
        .then(res => {
          if (!res.ok) throw new Error('Erro ao criar projeto');
          return res.json();
        })
        .then(() => {

          window.location.reload();

        })
        .catch(err => {
          console.error('Erro ao criar projeto:', err);
          // alert('Erro ao criar projeto.');
          this.abrirAlert(
            "Erro",
            "Não foi possível criar o projeto. Tente novamente mais tarde.",
            "error"
          );
        });
    },

    duplicarProjeto(projeto) {
      if (!projeto || !projeto.cod) return;

      this.abrirLoading();

      fetch(`${process.env.VUE_APP_BACKEND_URL}/duplicar-projeto`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          codProjeto: projeto.cod,
          emailUsuario: this.usuarioLogado.email
        }),
      })
        .then(res => {
          if (!res.ok) throw new Error('Erro ao duplicar projeto');
          return res.json();
        })
        .then(() => {
          window.location.reload();
        })
        .catch(err => {
          console.error('Erro ao duplicar projeto:', err);
          this.abrirAlert('Erro', 'Erro ao duplicar projeto.', 'error');
        })
        .finally(() => {
          this.fecharLoading();
        });
    },

    abrirModalDelete(projeto) {
      this.projetoSelecionadoParaDeletar = projeto;
    },

    // Confirmar delete
    confirmarDelete() {
      if (!this.projetoSelecionadoParaDeletar) return;

      const cod = this.projetoSelecionadoParaDeletar.cod;

      fetch(`${process.env.VUE_APP_BACKEND_URL}/deletar-projeto/${cod}`, { method: 'DELETE' })
        .then(() => {

          window.location.reload();

        })
        .catch(err => console.error("Erro ao deletar projeto:", err));
    },

    abrirModalCompartilhar(projeto) {
    // 1 - Define o projeto selecionado (ESSENCIAL)
    this.projetoSelecionadoParaCompartilhar = {
      ...projeto,
      emailsCompartilhados: []
    };

    this.emailCompartilhar = '';

    // 2 - Busca sempre do backend (mesmo após refresh)
    fetch(`${process.env.VUE_APP_BACKEND_URL}/projetos/emails-compartilhados/${projeto.cod}`)
    .then(res => res.json())
    .then(data => {
      if (Array.isArray(data.emailsCompartilhados)) {
        this.projetoSelecionadoParaCompartilhar.emailsCompartilhados =
          data.emailsCompartilhados.map(email => email.email);
      }
    })
    .catch(err => {
      console.error('Erro ao buscar emails compartilhados:', err);
    })
  },

  confirmarCompartilhamento() {
    // Normaliza o email
    this.emailCompartilhar = this.emailCompartilhar
      .trim()
      .toLowerCase();

    // 1 - Validação básica
    if (!this.emailCompartilhar) {
      this.abrirAlert(
        'Sistema',
        'Informe um e-mail válido para compartilhar.',
        'warning'
      );
      return;
    }

    // 2 - Projeto selecionado
    const projeto = this.projetoSelecionadoParaCompartilhar;
    if (!projeto || !projeto.cod) {
      console.error('Nenhum projeto selecionado para compartilhar');
      return;
    }

    // 3 - Chamada ao backend
    fetch(`${process.env.VUE_APP_BACKEND_URL}/compartilhar-projeto`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        codProjeto: projeto.cod,
        emailAutor: this.usuarioLogado.email,
        emailCompartilhar: this.emailCompartilhar
      })
    })
      .then(res => res.json())
      .then(data => {
        // 4 - Tratamento de erro do backend
        if (data.error) {
          this.abrirAlert('Erro', data.error, 'danger');
          return;
        }

        // 5 - Atualização local (UX imediata)
        if (!Array.isArray(projeto.emailsCompartilhados)) {
          projeto.emailsCompartilhados = [];
        }

        // Evita duplicar no frontend
        if (!projeto.emailsCompartilhados.includes(this.emailCompartilhar)) {
          projeto.emailsCompartilhados.push(this.emailCompartilhar);
        }

        const emailCompartilhado = this.emailCompartilhar;
        this.emailCompartilhar = '';

        this.abrirAlert(
          'Projeto compartilhado',
          `O projeto foi compartilhado com ${emailCompartilhado}.`,
          'success'
        );

      })
      .catch(err => {
        console.error('Erro ao compartilhar projeto:', err);
        this.abrirAlert(
          'Erro',
          'Erro ao compartilhar projeto.',
          'danger'
        );
      });
    },

    removerCompartilhamento(email) {
      const projeto = this.projetoSelecionadoParaCompartilhar;

      if (!projeto || !projeto.cod) return;

      fetch(`${process.env.VUE_APP_BACKEND_URL}/remover-compartilhamento`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          codProjeto: projeto.cod,
          emailAutor: this.usuarioLogado.email,
          emailRemover: email
        })
      })
        .then(res => res.json())
        .then(data => {
          if (data.error) {
            this.abrirAlert('Erro', data.error, 'danger');
            return;
          }

          // Atualização imediata no frontend
          projeto.emailsCompartilhados =
          projeto.emailsCompartilhados.filter(e => e !== email);

          window.location.reload();

        })
        .catch(err => {
          console.error(err);
          this.abrirAlert(
            'Erro',
            'Erro ao remover compartilhamento.',
            'danger'
          );
        });
    },

    abrirModalRename(projeto) {
      this.projetoSelecionadoParaRenomear = projeto;
      document.getElementById('renomearComponente').value = projeto.nome;
    },

    // Confirmar rename
    confirmarRename() {
      const projeto = this.projetoSelecionadoParaRenomear;

      if (!projeto) return;

      fetch(`${process.env.VUE_APP_BACKEND_URL}/renomear-projeto`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          codProjeto: projeto.cod,
          novoNome: this.novoNomeProjeto
        }),
      })
      .then(() => {

        window.location.reload();

        // Fechar modal
        // document.querySelector(`#modalRenomearProjeto [data-bs-dismiss="modal"]`)?.click();

        // projeto.nome = this.novoNomeProjeto; // atualiza localmente
        // this.projetoSelecionadoParaRenomear = null;
        // this.novoNomeProjeto = '';

      })
      .catch(err => console.error("Erro ao renomear projeto:", err));
    },

  }
};
</script>

<style>
#container { 
  min-width: 60%; max-width: 100% !important; 
}

h5 { 
  color: #3e4449; 
}

.projetos-filtros {
  margin-bottom: 24px !important;
  padding-bottom: 0;
}

.projetos-filtros .form-label {
  display: block;
  margin-bottom: 8px;
  color: #596579;
  font-size: 0.78rem;
  font-weight: 700;
}

.projeto-item { display: flex; align-items: center; cursor: pointer; }
.projectulos {
  margin: 10px;
  color: #32373b;
  font-size: 14px;
  background-color: #F0F4F9;
  border: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 55px;
  flex-grow: 1;
}
.icon-user { width: 18px; }

.titulo-secao-projeto {
  color: #172033;
  font-size: 1rem;
  font-weight: 700;
  margin-top: 48px !important;
  margin-bottom: 24px !important;
}

.titulo-secao-projeto:first-child {
  margin-top: 0;
}

.titulo-secao-projeto-compartilhados {
  margin-top: 48px !important;
  margin-bottom: 36px !important;
}

.projetos-compartilhados-blocos {
  margin-top: 0;
  padding-top: 0;
}

.table-responsive + .table-responsive {
  margin-top: 24px;
}

.tabela-projetos {
  width: 100%;
  min-width: 760px;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #EDEFF2;
  border-radius: 12px;
  overflow: visible;
  margin-bottom: 0;
}

.tabela-projetos-container {
  overflow-x: auto;
}

.tabela-projetos thead th {
  padding: 12px 14px;
  border-bottom: 1px solid #EDEFF2;
  background: #F8FAFC;
  color: #6B7280;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.tabela-projetos tbody tr {
  background: #ffffff;
}

.tabela-projetos tbody tr:hover {
  background: #f4f8ff;
}

.tabela-projetos tbody td:has(.dropdown-menu.show) {
  position: relative;
  z-index: 10;
}

.tabela-projetos tbody td {
  padding: 14px;
  border-bottom: 1px solid #EDEFF2;
  color: #2e3a4d;
  font-size: 0.82rem;
  vertical-align: middle;
}

.tabela-projetos tbody tr:last-child td { border-bottom: 0; }
.tabela-projetos tbody tr:last-child td:first-child { border-bottom-left-radius: 12px; }
.tabela-projetos tbody tr:last-child td:last-child { border-bottom-right-radius: 12px; }
.tabela-projetos thead th:first-child { border-top-left-radius: 11px; }
.tabela-projetos thead th:last-child { border-top-right-radius: 11px; }

.titulo-projeto {
  color: inherit;
  text-decoration: none;
}

.titulo-projeto:hover {
  color: inherit;
  text-decoration: none;
}

.titulo{
  color: #001232BF;
  font-size: 18px;
  font-weight: 600;
}

.botao-azul{
  background-color: #0056FF;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 800;
  text-transform: none;
  width: fit-content;
  min-width: fit-content;
  white-space: nowrap;
}

.lupa-busca, .input-projeto, .botao-azul, .btn-secundario {
  height: 40px !important;
}

.modal-novo-projeto .btn-secundario {
  background-color: #EDEFF2 !important;
  color: #3E4449 !important;
  font-weight: 600;
  border-radius: 8px;
  padding: 10px 16px;
  border: none;
}

.modal-novo-projeto .btn-secundario:hover {
  background-color: #e2e5e9 !important;
  color: #3E4449 !important;
}

.compartilhamentos-lista {
  border: 1px solid #e5eaf1;
  border-radius: 10px;
  overflow: hidden;
  background: #fbfcfe;
}

.compartilhamentos-lista__cabecalho {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border-bottom: 1px solid #e5eaf1;
}

.compartilhamentos-lista__titulo,
.compartilhamentos-lista__subtitulo {
  display: block;
}

.compartilhamentos-lista__titulo {
  color: #172033;
  font-size: 0.82rem;
  font-weight: 800;
}

.compartilhamentos-lista__subtitulo {
  margin-top: 2px;
  color: #8793a1;
  font-size: 0.72rem;
}

.compartilhamentos-lista__contador {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  height: 26px;
  padding: 0 8px;
  border-radius: 999px;
  background: #e8f0ff;
  color: #0056ff;
  font-size: 0.75rem;
  font-weight: 800;
}

.compartilhamentos-tabela {
  min-width: 0;
  width: 100%;
}

.compartilhamentos-tabela thead th {
  padding: 10px 16px;
  border-bottom: 1px solid #e5eaf1;
  background: #f4f7fb;
  color: #8793a1;
  font-size: 0.67rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.compartilhamentos-tabela tbody td {
  padding: 11px 16px;
  border-bottom: 1px solid #edf0f4;
  color: #2e3a4d;
  font-size: 0.82rem;
}

.compartilhamentos-tabela tbody tr:last-child td {
  border-bottom: 0;
}

.compartilhamento-destinatario {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.compartilhamento-destinatario__icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #e8f0ff;
  color: #0056ff;
  font-size: 0.8rem;
}

.compartilhamento-destinatario__email {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.compartilhamento-remover {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #b42318;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.compartilhamento-remover:hover {
  background: #fff0ef;
  color: #8f1d14;
}

/* HOVER BOTÃO AZUL (CONFIRMAR / CREATE) */
.botao-azul {
  background-color: #0056FF;
  transition: background-color 0.15s ease;
}

.botao-azul:hover {
  background-color: #000000 !important;
  border-color: #000000 !important;
}

.pagination-projetos {
  margin-top: 24px;
  gap: 6px;
}

.pagination-projetos .page-item {
  margin: 0;
}

.pagination-projetos .page-link {
  min-width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border: 1px solid #EDEFF2;
  border-radius: 8px !important;
  color: #3E4449;
  background-color: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
}

.pagination-projetos .page-link:hover {
  color: #0056FF;
  background-color: #EDF7FF;
  border-color: #0056FF;
}

.pagination-projetos .page-item.active .page-link {
  color: #FFFFFF;
  background-color: #0056FF;
  border-color: #0056FF;
}

.pagination-projetos .page-item.disabled .page-link,
.pagination-projetos .page-link:disabled {
  color: #AAB0B6;
  background-color: #F5F6F7;
  border-color: #EDEFF2;
  opacity: 1;
}

/* BLOCOS */
.projeto-card {
  border-radius: 12px;
  border: 1px solid #EDEFF2;
  background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);
  transition: all 0.2s ease;
  position: relative;
}

.projeto-card:hover {
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
  transform: translateY(-2px);
}

.card{
  margin-bottom: 0px !important;
}

.folder-icon {
  background: #F0F4FF;
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.projeto-nome {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.3;
  margin-bottom: 4px;
}

.projeto-menu {
  position: absolute;
  top: 8px;
  right: 8px;
}

.projeto-compartilhado-icon {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 12px;
  color: #0056FF;
  background: #F0F4FF;
  padding: 6px 10px;
  margin: 0;
  border-radius: 8px;
}

#tres-pontinhos-projetos {
  font-size: 12px;
  color: #0056FF;
  background-color: #EDF7FF !important;
  padding: 6px 10px;
  border-radius: 8px;
}

/* TAMANHO DOS ÍCONES VISUAIS DOS PROJETOS */

@media (min-width: 1920px)  {
  .icones-projetos {
    flex: 0 0 25%;
    max-width: 25%;
  }
}

@media (min-width: 1280px) and (max-width: 1919px) {
  .icones-projetos {
    flex: 0 0 33.3%;
    max-width: 33.3%;
  }
}

/* RESPONSIVIDADE MOBILE */
@media (min-width: 768px) {
  .w-sm-50 {
    width: 50% !important;
  }

}

/* APENAS CELULAR */
@media (max-width: 575px) {
  .form-select {
    display: none !important;
  }
}


</style>
